<template>
  <div>
    <v-btn v-if="notAuthor" color="success" @click="dialog = true">
      Request Author Access
    </v-btn>
    <v-dialog v-model="dialog" max-width="550px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Request Author Access
          </span>
        </v-card-title>
        <v-card-text>
          <p v-if="isSignedIn">
            Are you interested in becoming a curriculum author for the KCCTE Resource Library? Click the button below and we will follow-up with you on more details with creating your first curriculum.
          </p>
          <p v-else>
            Are you interested in becoming a curriculum author for the KCCTE Resource Library? Click the button below to setup your account - be sure to click the option "I want to become an author". We will follow-up with you on more details with creating your first curriculum.
          </p>
          <p>
            Need more information? <a href="https://kccte.pittstate.edu/resources/" target="_blank" class="text-deco">Visit our FAQ page</a> to learn more about submitting materials and developing curriculum for the KCCTE Resource Library.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="dialog = false">
            Close
          </v-btn>
          <v-btn v-if="isSignedIn" color="success" @click="requestAccess">
            I would like to become an author
          </v-btn>
          <v-btn v-else color="success" href="/Register/Index">
            Register Today
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapActions } from 'vuex';

  export default {
    props: {
      notAuthor: Boolean,
      isSignedIn: Boolean,
    },

    data: () => ({
      dialog: false,
    }),

    methods: {
      ...mapActions({
        setToast: 'toasts/addToGlobalToastQueue',
      }),

      async requestAccess() {
        try {
          await axios.post('/api/profile/request-author-access');
          this.setToast({
            color: 'green',
            message: 'We will reach out to you shortly with more information!',
            multiline: false,
          });
        } catch (error) {
          this.setToast({
            color: 'danger',
            message: 'We were not able to process your request. Please try again, or contact us for additional support.',
            multiline: true,
          });
        }
      },
    },
  };
</script>